import React from 'react'
import { Outlet } from 'react-router-dom'

const Kostil = () => {
  return (
    <div className="three-ds-wrapper text-neutral-900 bg-white" dir="ltr" style={{ color: '#171717', direction: 'ltr' }}>
      <Outlet />
    </div>
  )
}

export default Kostil
